// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/get_today_daily_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DailyItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetTodayDailyItemRequest
 */
export class GetTodayDailyItemRequest extends Message<GetTodayDailyItemRequest> {
  constructor(data?: PartialMessage<GetTodayDailyItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetTodayDailyItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTodayDailyItemRequest {
    return new GetTodayDailyItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTodayDailyItemRequest {
    return new GetTodayDailyItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTodayDailyItemRequest {
    return new GetTodayDailyItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTodayDailyItemRequest | PlainMessage<GetTodayDailyItemRequest> | undefined, b: GetTodayDailyItemRequest | PlainMessage<GetTodayDailyItemRequest> | undefined): boolean {
    return proto3.util.equals(GetTodayDailyItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetTodayDailyItemResponse
 */
export class GetTodayDailyItemResponse extends Message<GetTodayDailyItemResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.DailyItem daily_items = 1;
   */
  dailyItems: DailyItem[] = [];

  constructor(data?: PartialMessage<GetTodayDailyItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetTodayDailyItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "daily_items", kind: "message", T: DailyItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTodayDailyItemResponse {
    return new GetTodayDailyItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTodayDailyItemResponse {
    return new GetTodayDailyItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTodayDailyItemResponse {
    return new GetTodayDailyItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTodayDailyItemResponse | PlainMessage<GetTodayDailyItemResponse> | undefined, b: GetTodayDailyItemResponse | PlainMessage<GetTodayDailyItemResponse> | undefined): boolean {
    return proto3.util.equals(GetTodayDailyItemResponse, a, b);
  }
}

